import { Button, Dialog, DialogBody, DialogFooter } from "@blueprintjs/core";
import { useGetLocationQuery } from "@package/ui-gql/index-data-access";
import { useReloadLocation } from "../../../../hooks/use-reload-location";

type DialogReloadLocationProps = {
  isOpen: boolean;
  locationId?: string;
  onClose: () => void;
  onReload: () => void;
};

export function DialogReloadLocation({
  isOpen,
  locationId,
  onClose,
  onReload,
}: DialogReloadLocationProps) {
  const reload = useReloadLocation();

  const { data } = useGetLocationQuery({
    variables: {
      id: locationId ?? "",
    },
    skip: !locationId,
  });

  return (
    <Dialog
      icon="refresh"
      isOpen={isOpen}
      onClose={() => onClose()}
      title="Reload Location"
    >
      <DialogBody>
        <div className="flex flex-col w-full items-center">
          <h5 className="bp6-heading mt-2 mb-4">
            Reload: {data?.item?.name ?? "(Loading...)"}
          </h5>
        </div>
        <p className="italic mb-2">
          The location will be reloaded with the latest updates made in the CMS.
          A reload happens in the background of the application causing no
          interuption to the location running. The reload scheduling occurs in 5
          minute intervals. Scheduling multiple location reloads within 5
          minutes will result in only one reload being scheduled.
        </p>
      </DialogBody>
      <DialogFooter
        actions={
          <>
            <Button intent="none" text="Cancel" onClick={() => onClose()} />
            <Button
              className="ml-2"
              disabled={!locationId}
              intent="primary"
              text="Schedule Reload"
              onClick={() => {
                if (locationId) {
                  reload(locationId);
                }
                onReload();
                onClose();
              }}
            />
          </>
        }
      />
    </Dialog>
  );
}
